import React from 'react';

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="admin-section admin-page-header">
      <div className="admin-page-header-row">
        <div className="admin-page-header-copy">
          <h2 className="admin-page-title">{title}</h2>
          {subtitle ? <p className="admin-page-subtitle">{subtitle}</p> : null}
        </div>
        {actions ? <div className="admin-page-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
